module.exports = __webpack_public_path__ + "../resources/images/illustration_mention-976b8cbcac9808c2c0ffa99878ff94ef.svg";